module.exports = __webpack_public_path__ + "img/product-icon_15.be886fe4.png";